export default __webpack_public_path__ + "static/media/stats-icon-hover.5735d3c7.svg";